var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$apollo.loading)?_c('faq-block',{attrs:{"elements":_vm.vragen,"vragen":"","header-txt":"Veelgestelde vragen"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }